import enEl from 'element-ui/lib/locale/lang/en';
import faEl from 'element-ui/lib/locale/lang/fa';
import chEl from 'element-ui/lib/locale/lang/zh-CN';

import translations from './translations';

/* eslint-disable no-param-reassign */
function getLocale(lang) {
  return Object.keys(translations).reduce((acc, key) => {
    let translation = '';
    switch (lang) {
      case 'ch':
        translation = translations[key][2];
        break;
      case 'en':
        translation = translations[key][0];
        break;
      case 'fa':
        translation = translations[key][1];
        break;
      default:
        translation = translations[key][0];
        break;
    }
    acc[key] = translation;
    return acc;
  }, {});
}

export default {
  ch: { ...getLocale('ch'), ...chEl },
  en: { ...getLocale('en'), ...enEl },
  fa: { ...getLocale('fa'), ...faEl },
};
